import { LICENSE_STATUSES } from "./interfaces";

export const LICENSE_DETAILS_INIT = {
  multiState: false,
  status: LICENSE_STATUSES.PENDING,
  state: "Any",
  qualification: "",
  number: "",
  expiresAt: "",
  issueDate: "",
};

export const LICENSE_STATUS_TAG_COLORS = {
  [LICENSE_STATUSES.ACTIVE]: "success",
  [LICENSE_STATUSES.PENDING]: "processing",
  [LICENSE_STATUSES.REJECTED]: "error",
  [LICENSE_STATUSES.EXPIRED]: "error",
  [LICENSE_STATUSES.EXPIRING]: "warning",
};

export const STATUS_CHANGE_ALERT_TITLES = {
  [LICENSE_STATUSES.ACTIVE]: "Set License to Active?",
  [LICENSE_STATUSES.PENDING]: "Revert License to Pending?",
  [LICENSE_STATUSES.REJECTED]: "Set License to Rejected?",
  [LICENSE_STATUSES.EXPIRED]: "Set License to Expired?",
  [LICENSE_STATUSES.ARCHIVED]: "Archive License?",
};

export const LICENSE_STATUSES_VALUE_MAPPING = {
  [LICENSE_STATUSES.ACTIVE]: "Active",
  [LICENSE_STATUSES.PENDING]: "Pending",
  [LICENSE_STATUSES.REJECTED]: "Rejected",
  [LICENSE_STATUSES.EXPIRED]: "Expired",
  [LICENSE_STATUSES.ARCHIVED]: "Archived",
  [LICENSE_STATUSES.EXPIRING]: "Expiring",
};

export const LICENSE_STATUSES_LIST = [
  LICENSE_STATUSES.PENDING,
  LICENSE_STATUSES.ACTIVE,
  LICENSE_STATUSES.EXPIRED,
  LICENSE_STATUSES.REJECTED,
  LICENSE_STATUSES.ARCHIVED,
];

export const IMAGE_TYPES = [
  "apng",
  "bmp",
  "gif",
  "ico",
  "cur",
  "jpg",
  "jpeg",
  "jfif",
  "pjpeg",
  "pjp",
  "png",
  "svg",
  "webp",
];

export const LICENSE_REJECTION_REASONS = {
  DOCUMENT_EXPIRED: "Document Expired",
  DOCUMENT_INCOMPLETE: "Document Incomplete",
  INCORRECT_DOCUMENT: "Incorrect Document",
};

export const LICENSE_ACTIONS = {
  ADDED: "ADDED",
  UPDATED: "UPDATED",
};

export const DUPLICATE_LICENSE_INFO_TEXT = {
  ACTIVE:
    "This Worker already has a license for this state and worker type. Please enter new license info!",
  PENDING:
    "This Worker has already added a license for this state and worker type. Please allow time for the license to be verified!",
};

export const NON_LICENSE_ACTIVE = "User doesn't have any active license yet";
